import React from "react";
import { twMerge } from "tailwind-merge";
import ButtonSpinner from "../../ui/spinner/ButtonSpinner";

type IButton = {
  title: string;
  titleColor?: string;
  icon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  loading?: boolean;
  type?: "submit" | "button";
  onHandler: () => void;
  bg_color?: string;
  bg_hoverColor?: string;
  text_color?: string;
  className?: string;
  translateClassName?: string;
  disabled?: boolean;
};

const Button: React.FC<IButton> = ({
  title,
  icon,
  rightIcon,
  bg_color,
  bg_hoverColor,
  text_color = "text-white",
  loading,
  type,
  onHandler,
  titleColor,
  className,
  translateClassName = "-translate-x-full",
  disabled,
}) => {
  return (
    <button
      type={type}
      onClick={onHandler}
      disabled={disabled || loading}
      className={twMerge(
        `group relative flex justify-center items-center px-6 py-3 cursor-pointer md:text-md font-semibold  ${text_color} outline-none ${bg_color} overflow-hidden`,
        className,
      )}
    >
      <span
        className={`absolute inset-0 w-full h-full transition-all duration-300 ease-out transform ${translateClassName} ${bg_hoverColor} group-hover:translate-x-0`}
      ></span>

      {loading && <ButtonSpinner />}
      <div className={`relative flex items-center gap-3 ${titleColor}`}>
        {icon && <span>{icon}</span>}
        <span>{title}</span>
        {rightIcon && <span>{rightIcon}</span>}
      </div>
    </button>
  );
};

export default Button;
